/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RootReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { combineReducers } from "redux";
import spinnerReducer from "./spinner";
import authReducer from "./authReducer";
import profileReducer from "./profileReducer";
import countryAndPhoneCodeReducer from "./countryAndPhoneCodeReducer";
import userManagementReducer from "./userManagementReducer";
import fileHandlingReducers from "./fileHandlingReducers";
import settingsReducer from "./settingsReducer";
import adminSettingsReducer from "./adminSettingsReducer";
import vehicleFunctionReducer from "./vehicleFunctionReducer";
import powerTrainClassReducer from "./powerTrainClassReducer";
import vehicleClassReducer from "./vehicleClassReducer";
import architectureTypesReducer from "./architectureTypesReducer";
import swaggerReducer from "./swaggerDocs";
import projectConfigReducer from "./projectConfigReducer";
import labCarReducer from "./labCarReducer";
import typeApprovalReducer from "./typeApprovalReducer";
import legalRequirementsReducer from "./legalRequirementsReducer";
import softwareToSoftwareIntersectionReducer from "./softwareToSoftwareIntersectionsReducer";
import mftDetailsReducer from "./mftReducers";
import deliveryMarketReducers from "./deliveryMarketReducers";
import userDetailsReducer from "./userDetailsReducer";
import vehicleStatusReducer from "./vehicleStatusReducer";
import vehicleSystemsReducer from "./vehicleSystemsReducer";
import editRequestReducer from "./editRequestReducer";
import variantReducer from "./variantReducer";
import dynamicTemplateReducer from "./dynamicTemplateReducer";
import documentLibraryReducer from "./documentLibraryReducer";
import smartMatchingReducer from "./smartMatchingReducer";
import testCasesReducer from "./testCasesReducer";
import githubIntegrationReducer from "./githubIntegrationReducer";
import ruleEngineReducer from "./ruleEngineReducer";
import networkInterfacesReducer from "./networkInterfacesReducer";
import mfaReducer from "./mfaReducer";
import integrationConfigReducer from "./integrationConfigReducer";
import smartMatchReducer from "./smart-matching/smartMatchingReducer";
import policyReducer from "./policyReducer";
import roleTypeReducers from "./roleTypeReducers";
import reportTemplateReducer from "./reports/reportingTemplatesReducer";

const appReducer = combineReducers({
  spinnerReducer: spinnerReducer,
  authReducer: authReducer,
  userManagementReducer: userManagementReducer,
  settingsReducer: settingsReducer,
  profileReducer: profileReducer,
  fileHandlingReducers: fileHandlingReducers,
  countryAndPhoneCodeReducer: countryAndPhoneCodeReducer,
  adminSettingsReducer: adminSettingsReducer,
  powerTrainClassReducer: powerTrainClassReducer,
  vehicleFunctionReducer: vehicleFunctionReducer,
  vehicleClassReducer: vehicleClassReducer,
  architectureTypesReducer: architectureTypesReducer,
  swagger: swaggerReducer,
  projectConfigReducer: projectConfigReducer,
  labCarReducer: labCarReducer,
  typeApprovalReducer: typeApprovalReducer,
  legalRequirementsReducer: legalRequirementsReducer,
  softwareToSoftwareIntersectionReducer: softwareToSoftwareIntersectionReducer,
  mftDetailsReducer: mftDetailsReducer,
  deliveryMarketReducers: deliveryMarketReducers,
  userDetailsReducer: userDetailsReducer,
  vehicleStatusReducer: vehicleStatusReducer,
  vehicleSystemsReducer: vehicleSystemsReducer,
  editRequestReducer: editRequestReducer,
  variantReducer: variantReducer,
  dynamicTemplateReducer: dynamicTemplateReducer,
  documentLibraryReducer: documentLibraryReducer,
  smartMatchingReducer: smartMatchingReducer,
  testCasesReducer: testCasesReducer,
  githubIntegrationReducer: githubIntegrationReducer,
  ruleEngineReducer: ruleEngineReducer,
  networkInterfacesReducer: networkInterfacesReducer,
  mfa_management: mfaReducer,
  integrationConfigReducer: integrationConfigReducer,
  smartMatchReducer: smartMatchReducer,
  policyReducer: policyReducer,
  roleTypeReducers: roleTypeReducers,
  reportTemplateReducer: reportTemplateReducer,
});

const RootReducer = (state, action) => {
  if (action.type === "logoutOut") {
    state = undefined; // clears entire redux store
  }

  return appReducer(state, action);
};

export default RootReducer;
